(function($) {
    $(document).ready(function() {

        function setHeight(target) {

            var height = 0;

            // reset team heights to auto
            target.height('auto');


            target.each(function(e) {

                // if the height is greater than the tallest recorded height
                if($(this).outerHeight() > height) {
                    // set the new record
                    height = $(this).outerHeight();
                    // console.log(height);
                }

            });

            // after all items have been measured
            // set them all to the same height as the tallest item
            target.outerHeight(height);
        }

        var cardExcerpt = $('.js-card-height');
        setHeight( cardExcerpt );

        $(window).on('resize', function() {
            var cardExcerpt = $('.js-card-height');
            setHeight( cardExcerpt );
        });

    });
})(jQuery); 

